import React, { useEffect, useState } from "react";
//import "./productstable.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPencil,
    faTrash,
    faEye,
} from "@fortawesome/free-solid-svg-icons";
import Pagination from "../../common/Pagination";
import { useDispatch, useSelector } from "react-redux";


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from "@mui/material/Button";


import { useNavigate } from 'react-router-dom';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import AddCircleOutlineTwoToneIcon from '@mui/icons-material/AddCircleOutlineTwoTone';

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, TextField } from "@mui/material";
import { DataGrid, GridApi, GridColDef, GridValueGetterParams, GridCellParams } from '@mui/x-data-grid';
import { BrandsService } from "../../service/brands.service";

function BrandsTable() {

    const brandsService = new BrandsService();

    const [brandsData, setbrandsData] = useState<any[]>([]);

    //const [availableStatus, setAvailableStatus] = useState<OrderStatus[]>([]);

    const navigate = useNavigate();

    const toBrandDetails = (bIndex: string, action: string) => {


        navigate('../branddetails', {
            state: {
                brandDetails: brandsData[Number(bIndex) - 1],
                brandsData: brandsData,
                action: action
            }
        })
    };

    const [open, setOpen] = React.useState(false);



    const columns: GridColDef[] = [
        { field: 'brandId', headerName: 'ID', flex: 1, width: 300 },


        { field: 'brandImage', headerName: 'Image', flex: 1, sortable: false, renderCell: (params) => <img src={params.value} width="100" height="50" className="p-2" /> },
        { field: 'brandName', headerName: 'Brand Name', flex: 1 },
        {
            field: 'status', headerName: 'Status', flex: 1,

            renderCell: (params) => {
                return <div>
                    {params.value == -1 && (<p style={{ color: "blue" }}>Unknown</p>)
                        || params.value == 0 && (<p style={{ color: "red" }}>Deactive</p>)
                        || params.value == 1 && (<p style={{ color: "green" }}>Active</p>)
                    }

                </div>

            }

        },
        { field: 'visibility', headerName: 'Visibility', flex: 1 },
        {

            field: "action",
            headerName: "Action",
            sortable: false,
            renderCell: (params) => {
                const onClick = (e: { stopPropagation: () => void; }) => {
                    e.stopPropagation(); // don't select this row after clicking

                    const api: GridApi = params.api;
                    const thisRow: Record<string, GridCellParams> = {};

                    api
                        .getAllColumns()
                        .filter((c: { field: string; }) => c.field !== "__check__" && !!c)
                        .forEach(
                            (c: { field: string | number; }) => (thisRow[c.field] = params.value.getValue(params.id, c.field))
                        );
                };

                return <div>
                    <Button onClick={(e) => toBrandDetails(params.value, "edit")} > <IconButton> <EditTwoToneIcon fontSize="small" /></IconButton></Button>

                </div>
            },
            flex: 1
        }

    ];
    //useEffect(() => {
    const submitRequest = (checkApprovalStatus: number) => {

    }//, [selectedEnterprise, selectedStatus]);

    const loadbrandsData = () => {

        brandsService.brands(-1).then(data => {
            const res = data.data;
            let cnt1 = 0;
            const peopleWithImages = res.map((person: any, index: any) => {
                cnt1 = cnt1 + 1;
                return {
                    ...person,
                    id: cnt1,
                    action: cnt1 //person.brandId,
                };

            });
            setbrandsData(peopleWithImages)


        });

    }

    let isLoadDataInit = false;
    useEffect(() => {

        if (!isLoadDataInit) {
            isLoadDataInit = true;
            loadbrandsData();
        }

    }, [])


    return (
        <div className="App border card">
            <div className="col-md-12  row">
                <div className="col-10 text-right font_size_12px"></div>
               
            <div className="col-2 text-right">
                <Button size="small" style={{ color: "green" }} className="form-control text-right" onClick={() => navigate('../branddetails')} variant="text"
                    startIcon={<AddCircleOutlineTwoToneIcon />}>
                    Add New
                </Button>

            </div>
            </div>
            {
                <div style={{ width: '100%' }}>
                    <DataGrid
                        // table customization start
                        sx={{
                            '& .MuiDataGrid-columnHeaderTitle': {
                                whiteSpace: "break-spaces", lineHeight: 1, fontSize: "13px", fontWeight: "bold",
                            },
                            '& .MuiDataGrid-columnHeader': {
                                backgroundColor: "#D0D0D0"
                            },
                            '& .Mui-odd': {
                                textOverflow: "inherit", fontSize: "12px", textAlign: "left"
                            },

                            '& .Mui-even': {
                                backgroundColor: "#F7f7f7", textOverflow: "inherit", fontSize: "12px", textAlign: "left"

                            },

                            '& .Mui-cellown': {
                                paddingTop: 0, paddingBottom: 0

                            },

                        }}

                        getCellClassName={(params) => 'Mui-cellown'}
                        getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'}
                        autoHeight={true}
                        getRowHeight={() => 'auto'}

                        // table customization


                        rows={brandsData}
                        columns={columns}
                        initialState={{
                            pagination: {
                                paginationModel: { page: 0, pageSize: 10 },
                            },
                        }}
                        pageSizeOptions={[10, 25, 50]}

                    />
                </div>
            }
        </div>

    );
}


export default BrandsTable;
